/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBell = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M4 18.5V17h2v-6.5q0-2.075 1.25-3.688c.833-1.075 2.667-1.779 4-2.112V3.5h1.5v1.2c1.333.333 3.167 1.037 4 2.112Q18 8.425 18 10.5V17h2v1.5zM10.588 20.913q.587.587 1.412.587t1.413-.587Q14 20.325 14 19.5h-4q0 .825.588 1.413" /></svg>;
export default SvgBell;